import React from 'react';

/**
 * Logo Forfy - Componente React
 *
 * @param {Object} props
 * @param {'symbol' | 'full' | 'wordmark'} props.variant - Tipo di logo
 * @param {'auto' | 'light' | 'dark'} props.mode - Modalità colore (auto segue darkMode)
 * @param {string} props.size - Dimensione (es: 'xs', 'sm', 'md', 'lg', 'xl')
 * @param {string} props.className - Classi CSS aggiuntive
 * @param {boolean} props.darkMode - Stato dark mode dall'app
 */
export function Logo({
  variant = 'full',
  mode = 'auto',
  size = 'md',
  className = '',
  darkMode = false
}) {
  // Determina il colore della F in base alla modalità
  const getStrokeColor = () => {
    if (mode === 'light') return '#1A1A1A';
    if (mode === 'dark') return '#FAFAFA';
    // Auto: segue darkMode
    return darkMode ? '#FAFAFA' : '#1A1A1A';
  };

  // Dimensioni predefinite
  const sizes = {
    xs: { symbol: 24, wordmark: 14, gap: 6 },
    sm: { symbol: 32, wordmark: 18, gap: 8 },
    md: { symbol: 40, wordmark: 24, gap: 10 },
    lg: { symbol: 56, wordmark: 32, gap: 12 },
    xl: { symbol: 80, wordmark: 48, gap: 16 },
  };

  const sizeConfig = sizes[size] || sizes.md;
  const strokeColor = getStrokeColor();

  // Simbolo SVG inline
  const Symbol = ({ width, height }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="40" stroke="#FFAA85" strokeWidth="4"/>
      <path
        d="M38 30 L38 70 M38 30 L62 30 M38 50 L56 50"
        stroke={strokeColor}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="68" cy="30" r="8" fill="#FFAA85"/>
    </svg>
  );

  // Wordmark
  const Wordmark = ({ fontSize }) => (
    <span
      className="font-display font-semibold tracking-tight"
      style={{
        fontSize: `${fontSize}px`,
        color: strokeColor,
        lineHeight: 1,
      }}
    >
      forfy
    </span>
  );

  // Render basato sulla variante
  if (variant === 'symbol') {
    return (
      <div className={className}>
        <Symbol width={sizeConfig.symbol} height={sizeConfig.symbol} />
      </div>
    );
  }

  if (variant === 'wordmark') {
    return (
      <div className={className}>
        <Wordmark fontSize={sizeConfig.wordmark} />
      </div>
    );
  }

  // Default: full (symbol + wordmark)
  return (
    <div
      className={`flex items-center ${className}`}
      style={{ gap: `${sizeConfig.gap}px` }}
    >
      <Symbol width={sizeConfig.symbol} height={sizeConfig.symbol} />
      <Wordmark fontSize={sizeConfig.wordmark} />
    </div>
  );
}

export default Logo;
